import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import * as React from "react";
import Select from "../Select";
import { jsx as _jsx } from "react/jsx-runtime";
var MiniSelect = function MiniSelect(props) {
  return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, props), {}, {
    size: "small"
  }));
};
var MiddleSelect = function MiddleSelect(props) {
  return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, props), {}, {
    size: "middle"
  }));
};
MiniSelect.Option = Select.Option;
MiddleSelect.Option = Select.Option;
export { MiniSelect, MiddleSelect };